var map = {
	"./act_001.jpg": 1118,
	"./act_002.jpg": 1385,
	"./act_003.jpg": 4508,
	"./act_004.jpg": 2407,
	"./act_005.jpg": 4666,
	"./act_006.jpg": 389,
	"./bg-image.png": 2525,
	"./bottom.png": 5985,
	"./top.png": 2523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1042;